import React from 'react';
import { Header } from './Header';
import { Hero } from './Hero';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Testimonials } from './Testimonials';
import { SocialMediaHub } from './SocialMediaHub';
import { CTA } from './CTA';
import { QuoteForm } from './QuoteForm';
import { Contact } from './Contact';
import { Footer } from './Footer';

export const FullSite = () => {
  return (
    <>
      <Header />
      <Hero />
      <TrustBar />
      <Services />
      <Testimonials />
      <SocialMediaHub />
      <CTA />
      <QuoteForm />
      <Contact />
      <Footer />
    </>
  );
};
